import { Router } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
export class NavigationLinkService {
    constructor(router) {
        this.router = router;
    }
    isLink(element) {
        return (element.classList.contains('is-link') && element.hasAttribute('href'));
    }
    isInternalLink(element) {
        const url = element.getAttribute('href');
        return (!url.match('.*localhost.*') &&
            !url.match(NavigationLinkService.absoluteURLRegex));
    }
    mapActiveLinks(links) {
        return links.map(this.mapActiveLink.bind(this));
    }
    mapActiveLink(link) {
        const mappedLink = Object.assign({}, link, { active: this.router.isActive(link.url, !!link.exactMatch) });
        if (Array.isArray(mappedLink.children) && mappedLink.children.length) {
            mappedLink.children = mappedLink.children.map(this.mapActiveLink.bind(this));
        }
        return mappedLink;
    }
}
// TODO: Move this REGEX to a common utils
NavigationLinkService.absoluteURLRegex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
NavigationLinkService.ngInjectableDef = i0.defineInjectable({ factory: function NavigationLinkService_Factory() { return new NavigationLinkService(i0.inject(i1.Router)); }, token: NavigationLinkService, providedIn: "root" });
